(function() {
    'use strict';

    a3_cabin_reports.controller('NotificationModalCtrl', NotificationModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name NotificationModalCtrl
     * @description 
     * Shows Show Signature 
     * @ngInject
     */

    function NotificationModalCtrl($scope, $uibModalInstance){
        $scope.close = close;
        
        /**
         * Close the modal
         * @memberof NotificationModalCtrl
         */
        function close(){
            $uibModalInstance.close( $scope.success);
        }
    }
})();